import vertexShader from "./stage.vert"
import fragmentShader from "./stage.frag"

export default {
    uniforms: {
        tDiffuse: { value: null },
        opacity: { value: 1 },
        colorChange: { value: 0 },
    },
    vertexShader,
    fragmentShader,
    transparent: true,
}
